import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import DublinPlumbingHeatingBoilerSpecialists from "./sections/DublinPlumbingHeatingBoilerSpecialists";
import OurPlumbingHeatingServices from "./sections/OurPlumbingHeatingServices";
import WhyChooseD4PlumbingHeating from "./sections/WhyChooseD4PlumbingHeating";
import ServiceAreas from "./sections/ServiceAreas";
import CustomerReviews from "./sections/CustomerReviews";
import GetYourFreeQuoteToday from "./sections/GetYourFreeQuoteToday";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import BrandCTA from "./sections/BrandCTA";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <DublinPlumbingHeatingBoilerSpecialists />
      <OurPlumbingHeatingServices />
      <WhyChooseD4PlumbingHeating />
      <ServiceAreas />
      <CustomerReviews />
      <GetYourFreeQuoteToday />
      <FrequentlyAskedQuestions />
      <BrandCTA />
      <Footer />
    </div>;
}